import { AppPalette } from '../colors'

export const darkPalette = {
  primary: {
    main: AppPalette.NEUTRAL.white,
    contrastText: AppPalette.GREEN.second,
  },
  text: {
    main: AppPalette.GREY.secondary,
    secondary: AppPalette.GREY.dark,
  },
  background: {
    default: AppPalette.NEUTRAL.darker,
    overrideDefault: AppPalette.NEUTRAL.input,
    dark: AppPalette.NEUTRAL.darker,
    dialog: AppPalette.NEUTRAL.second,
    secondary: AppPalette.NEUTRAL.dark,
    bgIcon: AppPalette.GREY.fourth,
    bgIconFirst: AppPalette.BORDER.darker,
    hoverFirst: AppPalette.GREY.highlight_dark,
    bgButton: AppPalette.GREY.third,
  },
  highlight: {
    main: AppPalette.GREY.highlight_dark,
  },
  link: {
    main: AppPalette.BLUE.secondary,
  },
  overdueState: {
    overdue: AppPalette.SLA_STATE.overdue_dark,
    on_time: AppPalette.SLA_STATE.on_time_dark,
  },
  createTicketBackground: {
    main: AppPalette.NEUTRAL.darker,
  },
  border: {
    main: AppPalette.BORDER.dark,
    first: AppPalette.BORDER.darkBold,
    devider: AppPalette.BORDER.darker,
  },
  error: {
    main: AppPalette.RED.dark,
    light: AppPalette.RED.error,
  },
  color: {
    button: {
      icon: '#004744',
      label: '#004744',
      labelActive: '#66f0a0',
    },
    label: '#fff',
    chip: {
      label: '#fff',
      labelActive: '#66f0a0',
    },
    border: {
      box: '#1a3746',
    },
    text: {
      black: '#fff',
      white: '#000',
      tabHeaderActive: '#66f0a0',
      table: {
        header: '#002031',
        body: '#fff',
      },
    },
  },
  backgroundColor: {
    box: '#002031',
    wrapper: '#1a3746',
    table: {
      rowActive: '#9bb5b4',
    },
  },
}
